import React from 'react';
import { Row, Col, Typography, Image } from 'antd';
import SEO from '../components/SEO';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import LandingNavbar from '../layouts/Navbar';
import LandingFooter from '../layouts/Footer';

const { Title, Paragraph, Text } = Typography;

const MessageFromCEO = () => {
    return (
        <div style={{ fontFamily: 'Calibri, sans-serif', minHeight: '100vh', background: '#FFFAFC' }}>
            <SEO
                title="Message from Our CEO"
                description="A personal message from the CEO of Oottan on our mission to help every individual find their perfect life partner."
                canonical="/message-from-ceo"
            />
            <LandingNavbar />

            {/* ── Hero Banner ── */}
            <div style={{
                background: 'linear-gradient(135deg, #6A0572 0%, #880E6E 40%, #AD1457 80%, #D81B60 100%)',
                padding: '100px 24px 60px',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
            }}>
                <div style={{
                    position: 'absolute', inset: 0,
                    backgroundImage: 'radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)',
                    backgroundSize: '28px 28px',
                }} />
                <div style={{ position: 'relative', zIndex: 1 }}>
                    <Title style={{ color: 'white', fontSize: '2.4rem', fontWeight: '800', marginBottom: '12px', letterSpacing: '-0.5px' }}>
                        Message from Our CEO
                    </Title>
                    <Text style={{ color: 'rgba(255,255,255,0.78)', fontSize: '1rem' }}>
                        A personal note from the founder of Oottan
                    </Text>
                </div>
            </div>

            {/* ── Main Content ── */}
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '64px 24px' }}>
                <Row gutter={[48, 48]} align="top">

                    {/* Left — Photo */}
                    <Col xs={24} md={9}>
                        <div style={{ position: 'sticky', top: '90px' }}>
                            <div style={{
                                borderRadius: '20px', overflow: 'hidden',
                                boxShadow: '0 20px 60px rgba(173,20,87,0.18)',
                                marginBottom: '12px',
                            }}>
                                <Image
                                    src={`${process.env.REACT_APP_IMAGE_URL}/assets/images/Marriage_Pic.jpg`}
                                    alt="Er. Jerish Balakrishnan"
                                    style={{ width: '100%', display: 'block' }}
                                    preview={false}
                                />
                            </div>
                            <Text style={{ color: '#94A3B8', fontSize: '0.78rem', display: 'block', textAlign: 'center', fontStyle: 'italic' }}>
                                A beautiful memory from our wedding reception on December 29, 2025.
                            </Text>
                        </div>
                    </Col>

                    {/* Right — Letter */}
                    <Col xs={24} md={15}>
                        <div style={{
                            background: 'white', borderRadius: '20px',
                            padding: '48px', border: '1px solid rgba(173,20,87,0.08)',
                            boxShadow: '0 8px 40px rgba(173,20,87,0.08)',
                        }}>
                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                Dear Members,
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                Welcome to Oottan.
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                Finding the right life partner is one of the most important decisions we make in our lives. It is a journey built on trust, understanding, shared values, and mutual respect. I have always believed that meaningful relationships are not formed by chance—they are nurtured through honesty, compatibility, and a genuine commitment to one another.
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                My own journey reinforced this belief and inspired me to create a platform that helps others begin theirs with confidence. That inspiration became Oottan—a platform dedicated to bringing together individuals and families who are searching for genuine, lifelong relationships.
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                At Oottan, our mission is simple: to make the search for a life partner safe, transparent, and meaningful. We strive to combine the timeless values of trust and family with modern technology to create an experience that is both secure and personalized. Every profile, every feature, and every improvement we introduce is guided by one purpose—to help our members build lasting relationships with confidence.
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                We understand that behind every profile is a unique story, a family, and the hope of finding someone special. That is why we are committed to protecting your privacy, maintaining the authenticity of our community, and continuously improving our platform to serve you better.
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '20px', lineHeight: '1.8' }}>
                                As we grow, our commitment remains unwavering—to earn your trust through integrity, innovation, and exceptional service. We measure our success not by the number of registrations on our platform, but by the meaningful relationships and happy families that begin their journey with us.
                            </Paragraph>

                            <Paragraph style={{ fontSize: '1rem', color: '#374151', marginBottom: '32px', lineHeight: '1.8' }}>
                                Thank you for choosing Oottan to be a part of one of life's most beautiful milestones. On behalf of our entire team, I wish you happiness, companionship, and a lifetime filled with love, understanding, and cherished memories.
                            </Paragraph>

                            {/* CTA */}
                            <div style={{ textAlign: 'right' }}>
                                <Link
                                    to="/signup"
                                    style={{
                                        display: 'inline-flex', alignItems: 'center', gap: '8px',
                                        background: 'linear-gradient(135deg, #AD1457, #D81B60)',
                                        color: 'white', textDecoration: 'none',
                                        padding: '12px 24px', borderRadius: '10px',
                                        fontWeight: '700', fontSize: '0.9rem',
                                        boxShadow: '0 4px 16px rgba(173,20,87,0.3)',
                                    }}
                                >
                                    Join Us Today <ArrowRightOutlined />
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <LandingFooter />
        </div>
    );
};

export default MessageFromCEO;
